import { render, staticRenderFns } from "./GelirGiderTurForm.vue?vue&type=template&id=25674af3"
import script from "./GelirGiderTurForm.vue?vue&type=script&lang=ts"
export * from "./GelirGiderTurForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports